export default __webpack_public_path__ + "static/media/skill_up_logo.8c7b4591.svg";